import debounce from 'lodash.debounce'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  Button,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  // VisibilitySelector,
  ButtonOutline,
  TagAdder,
  AudienceSelect
} from '../../../components'
import { submissionStatus } from '../../../constants'
import { useInternationalization } from '../../../features/i18n'
import { updateForm } from '../../../features/resource-form/slice'
import service from '../../../features/resource/service'
import { SystemProvider } from '../../../features/system/provider'
import { TagProvider } from '../../../features/tag/hook/provider'
import { useViewport } from '../../../utils'
import { SidebarApproach } from './sidebar-approach'
import SidebarCategories from './sidebar-categories'
import { SidebarIssue } from './sidebar-issue'
import { SidebarStatus } from './sidebar-status'

const Sidebar = ({isEdit, requesting, handleSubmit}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const form = useSelector(state => state.resourceForm.data)
  const { isDesktop } = useViewport()
  const { translate, language } = useInternationalization()

  const {
    thumbnail,
    suitable,
    suitable__en,
    tags,
    id,
  } = form

  const handleInput = debounce((e) => {
    console.log('handle input', e)
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const handleImage = (e) => {
    if (e) {
      console.log(e)

      const name = e.name
      const type = e.type
      const blob = URL.createObjectURL(e)

      handleInput({
        target: {
          name: 'new_thumbnail',
          value: {name, type, blob}
        }
      })
    }
  }

  const handleDelete = () => {
    let c = window.confirm('Apakah anda yakin akan menghapus konten ini?')
    if(c){
      service.delete(id)
        .then(res => {
          console.log(res)
          toast.success('Resource successfully deleted!')
          history.push('/dashboard/resources')
        })
        .catch(err => {
          console.log(err)
          toast.error('Error.')
        })
    }
  }

  const handleDraft = (e) => {
    console.log('save as draft')
    e.preventDefault()
    e.stopPropagation()

    handleSubmit({submission: submissionStatus.draft})
  }

  return (
    <div>
      {
        isDesktop &&
        <div className="p-5 rounded mb-8" style={{background: '#f5f5f5'}}>
          <SidebarStatus isEdit={isEdit}/>

          <Button
            className="mb-3"
            disabled={requesting}
            isLoading={requesting}
          >
            <span>{translate('GENERAL', 'submit')}</span>
          </Button>

          <ButtonOutline
            transparent
            outlineColor="primary"
            className="text-primary uppercase font-accent py-4"
            disabled={requesting}
            isLoading={requesting}
            onClick={handleDraft}
          >
            <span>{translate('GENERAL', 'save_to_draft')}</span>
          </ButtonOutline>

          {
            isEdit && <>
              {/* <Link className="block link text-sm pt-4" to={`/resource/${id}/detail`}>
                View Resource
              </Link> */}

              <div
                className="mt-5 text-center text-xs text-gray-500 underline cursor-pointer"
                onClick={handleDelete}
              >
                {translate('GENERAL', 'delete')}
              </div>
            </>
          }
        </div>
      }

      <div className="mb-5 lg:mb-10">
        <ImagePickerSidebar
          defaultValue={thumbnail}
          label={translate('GENERAL', 'thumbnail_image')}
          onChange={handleImage}
          ratio="4:3"
        />
      </div>

      <div className="mb-5 lg:mb-10">
        <SidebarCategories />
      </div>

      {/* <div className="mb-5 lg:mb-10">
        <div className="mb-5 lg:mb-0">
          <Label>Visibility</Label>
        </div>
        <VisibilitySelector
          form={form}
          updateForm={updateForm}
        />
      </div> */}

      <SystemProvider>
        <div className="mb-5 lg:mb-10">
          <AudienceSelect
            defaultValues={language.name === 'id' ? suitable : suitable__en}
            updateForm={handleInput}
          />
        </div>

        <div className="mb-5 lg:mb-10">
          <SidebarApproach />
        </div>

        <div className="mb-5 lg:mb-10">
          <SidebarIssue />
        </div>
      </SystemProvider>

      <TagProvider>
        <div className="mb-8 lg:mb-10">
          <Label>Tag</Label>
          <TagAdder
            data={tags}
            onChange={(value) => {
              handleInput({
                target: {
                  name: 'tags',
                  value
                }
              })
            }}
          />
        </div>
      </TagProvider>

      {
        !isDesktop &&
        <div className="mb-10">
          <Button thin className="mb-3">
            {translate('GENERAL', 'submit')}
          </Button>
          <ButtonOutline
            transparent
            outlineColor="primary"
            className="text-primary uppercase font-accent"
          >
            {translate('GENERAL', 'save_to_draft')}
          </ButtonOutline>
        </div>
      }
    </div>
  )
}

export { Sidebar }
